import { ClientInferRequest } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

type Payload = ClientInferRequest<typeof contract.notifications.userFeedback>["body"];
export const sendUserFeedbacks = async (payload: Payload) => {
  const responnse = await api.notifications.userFeedback.mutation({
    body: payload,
  });

  return responnse;
};
